export default __webpack_public_path__ + "static/media/goodbyecar.334b5753.png";